<template>
  <div class="dropdown d-inline-block" v-if="optionsDropdownItems.length">
    <a class="dropdown-ellipses dropdown-toggle" data-toggle="dropdown" href="#!" role="button">
      <i class="fe fe-more-vertical"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-right">
      <a
        v-for="item in optionsDropdownItems"
        :key="item.text"
        @click="item.action"
        class="dropdown-item"
        href="javascript:;"
      >
        <span :class="item.type">{{ item.text }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const CompanyModule = createNamespacedHelpers('company')

export default {
  name: 'CampaignSetupsListRowDropdown',
  props: ['campaignSetup'],
  computed: {
    ...CompanyModule.mapGetters(['selectIsPermitted']),
    isDisabled() {
      return this.campaignSetup.status === 'disabled'
    },
    isActive() {
      return this.campaignSetup.status === 'active'
    },
    canEditCampaigns() {
      return this.selectIsPermitted('campaignsWriteAccess')
    },
    optionsDropdownItems() {
      // Every item here mutates a campaign, so a role without the Edit key gets no menu at all.
      if (!this.canEditCampaigns) return []

      return [
        {
          type: 'text-primary',
          text: 'Duplicate',
          action: () => {
            this.$emit('duplicate')
          }
        },
        ...(this.isDisabled
          ? [
              {
                type: 'text-success',
                text: 'Activate',
                action: () => {
                  this.$emit('toggle')
                }
              }
            ]
          : []),
        ...(this.isActive
          ? [
              {
                type: 'text-warning',
                text: 'Disable',
                action: () => {
                  this.$emit('toggle')
                }
              }
            ]
          : []),
        {
          type: 'text-danger',
          text: 'Delete',
          action: () => {
            this.$emit('delete')
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss"></style>
